import { createSelector } from 'reselect';
import sortBy from 'lodash/sortBy';
import get from 'lodash/get';

export const selectAllProducts = createSelector(
  state => get(state, 'requests.products.value', []),
  products => sortBy(products, 'order')
);
